import { flexStyle, textStyle } from '@themes/mixins';
import styled from 'styled-components';

export const DataDateContainer = styled.div`
  ${flexStyle({
    align: 'center',
    justify: 'flex-start',
    direction: 'row',
    wrap: 'nowrap',
  })};
  gap: 6px;
`;

export const Label = styled.span`
  ${textStyle({
    color: 'textSecondary',
    lineHeight: 1,
    size: '12px',
    textAlign: 'left',
    weight: 400,
  })};
`;

export const InfoIcon = styled.span`
  ${flexStyle({ align: 'center', justify: 'center' })};
  color: ${({ theme }) => theme.colors.textSecondary};
  cursor: help;
`;

/* Content rendered inside the MUI tooltip */
export const TooltipContent = styled.div`
  ${textStyle({ lineHeight: 1.4, size: '12px', weight: 400 })};
`;

export const TooltipList = styled.ul`
  margin: 6px 0;
  padding-left: 16px;
  list-style: none;

  li {
    margin: 2px 0;
  }
`;
